import { useFormContext, useFormState } from 'react-hook-form';
import { EpButton } from '../../../components';
import { useTranslationStore } from '../../../stores';
import { useTranslation as t } from '../../../hooks/useTranslation';

export const FormStepButtonConfirm = () => {
  const { translations } = useTranslationStore((state) => state);
  const { getValues, setValue } = useFormContext();
  const { isValid } = useFormState();

  const formInReview = getValues('formUtils.review');
  const stepNeedReview = getValues('formUtils.stepNeedReview');

  const formInLastStep =
    getValues('formUtils.activeStep') === getValues('formUtils.totalSteps');

  if (isValid && formInReview && !formInLastStep && stepNeedReview === '') {
    return (
      <EpButton
        buttonId="step-back"
        buttonSize="md"
        buttonType="primary"
        buttonText={t(translations['global'], 'Confirm Notification')}
        buttonOnClickFunc={() => setValue('formUtils.activeStep', getValues('formUtils.totalSteps'))
        }
      />
    );
  }

  return null;
};
